import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LlavesService {

  apiUrl: string = environment.REST_API.URL;
  constructor(private http: HttpClient) { }

  guardar(llaves) {
    return this.http.post(this.apiUrl + "llavesCriptograficas/guardarLlave", llaves);
  }

  actualizar(llaves) {
    return this.http.put(this.apiUrl + "llavesCriptograficas/actualizarLlave", llaves);
  }

  obtenerPagina(page: number, size: number) {
    return this.http.get(this.apiUrl + "llavesCriptograficas/obtenerLlaves?page=" + page + "&size=" + size);
  }

  obtenerPaginaLink(link) {
    return this.http.get(link);
  }

  guardarFragmentos(request) {
    return this.http.post(this.apiUrl + "llavesCriptograficas/guardarFragmentos", request);
  }

}
